import React, { useEffect, useState } from 'react';
import { numberFormat, colorFix } from '../../utils';

function DatagridCellPhaisinh({ data, type, sym, doubleClick, className }) {
  const [txtCl, setTxtCl] = useState('')
  const [val, setVal] = useState('')

  useEffect(() => {
    let txtCl, val, valOriginal;
    switch (type) {
      case 'lastPrice':
        txtCl =
          data.cl || colorFix(data.lastPrice, data.r, data.c, data.f, data.r);
        val = numberFormat(data.lastPrice, 1);
        valOriginal = data.lastPrice;
        setTxtCl(txtCl)
        setVal(val)
        break;
      case 'lastVolume':
        txtCl =
          data.cl || colorFix(data.lastPrice, data.r, data.c, data.f, data.r);
        val = numberFormat(data.lastVolume);
        setTxtCl(txtCl)
        setVal(val)
        break;
      case 'bP1':
        txtCl = data.bVC1;
        val = numberFormat(data.bP1, 1);
        valOriginal = data.bP1;
        setTxtCl(txtCl)
        setVal(val)
        break;
      case 'bV1':
        txtCl = data.bVC1;
        val = numberFormat(data.bV1);
        setTxtCl(txtCl)
        setVal(val)
        break;
      case 'bP2':
        txtCl = data.bVC2;
        val = numberFormat(data.bP2, 1);
        valOriginal = data.bP2;
        setTxtCl(txtCl)
        setVal(val)
        break;
      case 'bV2':
        txtCl = data.bVC2;
        val = numberFormat(data.bV2);
        setTxtCl(txtCl)
        setVal(val)
        break;
      case 'bP3':
        txtCl = data.bVC3;
        val = numberFormat(data.bP3, 1);
        valOriginal = data.bP3;
        setTxtCl(txtCl)
        setVal(val)
        break;
      case 'bV3':
        txtCl = data.bVC3;
        val = numberFormat(data.bV3);
        setTxtCl(txtCl)
        setVal(val)
        break;
      case 'oP1':
        txtCl = data.oVC1;
        val = numberFormat(data.oP1, 1);
        valOriginal = data.oP1;
        setTxtCl(txtCl)
        setVal(val)
        break;
      case 'oV1':
        txtCl = data.oVC1;
        val = numberFormat(data.oV1);
        setTxtCl(txtCl)
        setVal(val)
        break;
      case 'oP2':
        txtCl = data.oVC2;
        val = numberFormat(data.oP2, 1);
        valOriginal = data.oP2;
        setTxtCl(txtCl)
        setVal(val)
        break;
      case 'oV2':
        txtCl = data.oVC2;
        val = numberFormat(data.oV2);
        setTxtCl(txtCl)
        setVal(val)
        break;
      case 'oP3':
        txtCl = data.oVC3;
        val = numberFormat(data.oP3, 1);
        valOriginal = data.oP3;
        setTxtCl(txtCl)
        setVal(val)
        break;
      case 'oV3':
        txtCl = data.oVC3;
        val = numberFormat(data.oV3);
        setTxtCl(txtCl)
        setVal(val)
        break;
      default: {
        break;
      }
    }
  }, [])

  return (
    <td
      className={className + ' ' + txtCl}
      id={sym + type}
    >
      <span data-for={(type === 'lastPrice' ? 'pri' : type) + '_' + sym}>
        {val}
      </span>
    </td>
  );
}

export default DatagridCellPhaisinh;
